<template>
    <div class="modal fade" id="replace-product-modal" tabindex="-1" role="dialog" aria-labelledby="replace-product-modal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ __('replace_product.title') }}: {{ theProduct.name }} ({{ theProduct.number }})</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <form id="replace-product-form" @submit.prevent="saveProduct()">
                    <div class="modal-body">
                        <fieldset>
                            <legend>{{ __('replace_product.field.replacement_product.label') }}</legend>

                            <input type="text" class="form-control" v-model="replacementProductNumber" :placeholder="__('model.product.attr.number') | capitalize"/>

                            <div class="custom-control custom-checkbox mt-2">
                                <input type="checkbox" id="copy_product_if_not_exists" class="custom-control-input" v-model="copyProductIfNotExists">
                                <label for="copy_product_if_not_exists" class="custom-control-label">{{ __('replace_product.field.copy_product_if_not_exists.label') }}</label>
                            </div>
                        </fieldset>
                    </div>
                    <div class="modal-footer">
                        <div class="d-flex align-items-center justify-content-between gap-3">
                            <error-message :error="error" :timeout="true" classes="mt-3"></error-message>

                            <button type="submit" class="btn btn-primary" :disabled="globalVars.isLoading">
                                {{ __('replace_product.title') }} <i v-show="globalVars.isLoading" class="fas fa-circle-notch fa-spin"></i>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import ErrorMessage from '../ErrorMessage';
    import ConfirmButtons from '../util/ConfirmButtons';
    import ProductSelector from '../util/ProductSelector';

    export default {
        components: {
            ErrorMessage,
            ConfirmButtons,
            ProductSelector,
        },
        data() {
            return {
                error: new _Error(),
                theProduct: new Product(),

                replacementProductNumber: null,
                copyProductIfNotExists: false,
            };
        },
        props: {
            product: Object,
        },
        watch: {
            product: function () {
                this.theProduct = this.product;
            },
        },
        methods: {
            saveProduct() {
                if (!this.replacementProductNumber) {
                    this.error = new _Error(Status.WARNING, null, this.__('replace_product.field.replacement_product.required'));

                    return;
                }

                axios
                    .post(`/api/products/${this.theProduct.id}/replace/${this.replacementProductNumber}`, {
                        copy_product_if_not_exists: this.copyProductIfNotExists,
                    })
                    .then(response => {
                        this.error = response.data.error;

                        this.replacementProductNumber = null;
                        this.copyProductIfNotExists = false;
                    })
                    .catch(error => {
                        this.error = this.createErrorFromRequest(error);
                    });
            },
        },
    };
</script>
